import React from 'react';
import Icon from '../common/Icons';
import {
  CARE_MODE_FILTER_ALL,
  CARE_MODE_OPTIONS,
  SITE_STATUS_FILTERS
} from './siteListUtils';
import '../companies/CompanyListUx.css';

export default function SiteListFilters({
  search,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  careModeFilter,
  onCareModeFilterChange,
  hasActiveFilters = false,
  onClearFilters,
  onRefresh,
  loading = false,
  filteredCount = 0,
  repositoryTotal = 0
}) {
  return (
    <div className="co-list-filters">
      <div className="co-list-filters__row co-list-filters__row--primary">
        <label className="co-list-search">
          <Icon name="search" size={16} className="co-list-search__icon" aria-hidden />
          <input
            className="co-list-search__input"
            type="search"
            placeholder="Nom, adresse, contact, téléphone, mode métier…"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            aria-label="Rechercher un site"
            autoComplete="off"
          />
        </label>

        <div className="co-list-segment" role="group" aria-label="Filtrer par statut">
          {SITE_STATUS_FILTERS.map((filter) => (
            <button
              key={filter.id}
              type="button"
              aria-pressed={statusFilter === filter.id}
              className={`co-list-segment__btn ${statusFilter === filter.id ? 'is-active' : ''}`}
              onClick={() => onStatusFilterChange(filter.id)}
            >
              {filter.label}
            </button>
          ))}
        </div>
      </div>

      <div className="co-list-filters__row co-list-filters__row--secondary">
        <label className="co-list-field">
          <span className="co-list-field__label">Mode métier</span>
          <select
            className="co-list-field__select"
            value={careModeFilter}
            onChange={(e) => onCareModeFilterChange(e.target.value)}
            aria-label="Filtrer par mode de prise en charge"
          >
            <option value={CARE_MODE_FILTER_ALL}>Tous les modes</option>
            {CARE_MODE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </label>

        {hasActiveFilters ? (
          <button
            type="button"
            className="co-list-clear-btn"
            onClick={onClearFilters}
            aria-label="Réinitialiser tous les filtres"
          >
            <Icon name="times" size={14} aria-hidden />
            <span>Réinitialiser</span>
          </button>
        ) : null}

        <button
          type="button"
          className="co-list-refresh-btn"
          onClick={onRefresh}
          disabled={loading}
          title="Actualiser le répertoire"
          aria-label="Actualiser la liste des sites"
        >
          <Icon name="refresh" size={16} />
        </button>

        <div className="co-list-results-meta" role="status" aria-live="polite">
          <span className="co-list-results-meta__count">
            <strong>{filteredCount}</strong>
            <span>résultat{filteredCount > 1 ? 's' : ''}</span>
          </span>
          <span className="co-list-results-meta__total">répertoire : {repositoryTotal}</span>
        </div>
      </div>
    </div>
  );
}
